export default __webpack_public_path__ + "static/media/3233 utensils top.2caac8b6.png";